import api from '@api/Api';

export default {

    updateBlock(id, params) {
        return api().put(`/blocks/${id}`, params);
    },

    deleteBlock(id) {
        return api().delete(`/blocks/${id}`);
    },

}